export const formatInputDate = (input: string): string => {
  const cleaned = input.replace(/[^0-9.]/g, '');
  if (Number(input[0]) > 3) return '';
  if (Number(input.slice(0, 2)) > 31) return '31';
  if (Number(input[3]) > 1) return input.slice(0, 3);
  if (Number(input.slice(3, 5)) > 12) return `${input.slice(0, 2)}.12`;

  let formattedDate = '';

  for (let i = 0; i < cleaned.length; i++) {
    if (i === 2 || i === 5) {
      if (cleaned.charAt(i) !== '.') formattedDate += '.';
      else {
        formattedDate += cleaned.charAt(i);
      }
    }

    if (i !== 2 && i !== 5) {
      if (cleaned.charAt(i) === '.') {
        continue;
      } else {
        formattedDate += cleaned.charAt(i);
      }
    }
  }

  return formattedDate.slice(0, 10);
};
